import { EExamTypes } from '@constants';

export const StudentExamScoreTranslations = {
  MY_EXAMS_SCORES: {
    es: 'Mis calificaciones',
    en: 'My exams scores',
    cat: 'Les meves qualificacions',
    eus: 'Nire kalifikazioak',
    pt: 'Minhas classificações'
  },
  MY_EXAMS_SCORES_DESCRIPTION: {
    es: 'Exámenes y archivos online y presenciales puntuados.',
    en: 'Exams and online and face-to-face files scored.',
    cat: 'Exàmens i fitxers puntuats en línia i presencials.',
    eus: 'Emaitza-egingoak eta online eta aurrekoak puntuatuta.',
    pt: 'Exames e ficheiros online e presenciais pontuados.'
  },
  [EExamTypes.ONSITE]: {
    es: 'Exámenes presenciales',
    en: 'Presential exams',
    cat: 'Exàmens presencials',
    eus: 'Aurreko emaitza-egingoak',
    pt: 'Exames presenciais'
  },
  [EExamTypes.ONLINE]: {
    es: 'Exámenes online',
    en: 'Online exams',
    cat: 'Exàmens en línia',
    eus: 'Online emaitza-egingoak',
    pt: 'Exames online'
  },
  [EExamTypes.DELIVERABLE]: {
    es: 'Documentos entregables',
    en: 'Deliverable documents',
    cat: 'Documentos entregables',
    eus: 'Entregatutako dokumentuak',
    pt: 'Documentos entregáveis'
  },
  EXAM_SCORE: {
    es: 'Nota del examen',
    en: 'Exam score',
    cat: "Nota de l'examen",
    eus: 'Emaitza-egingoaren nota',
    pt: 'Nota do exame'
  },
  TEACHER_SCORE: {
    es: 'Nota del profesor',
    en: 'Teacher score',
    cat: 'Nota del professor',
    eus: 'Ikastarlearen nota',
    pt: 'Nota do professor'
  },
  DESCRIPTION: {
    es: 'Descripción',
    en: 'Description',
    cat: 'Descripció',
    eus: 'Deskribapena',
    pt: 'Descrição'
  },
  FILE: {
    es: 'Archivo',
    en: 'File',
    cat: 'Fitxer',
    eus: 'Fitxategia',
    pt: 'Ficheiro'
  },
  CONTENT: {
    es: 'Contenido',
    en: 'Content',
    cat: 'Contingut',
    eus: 'Edukia',
    pt: 'Conteúdo'
  },
  EXAM_DAY: {
    es: 'Día del examen',
    en: 'Exam day',
    cat: "Dia de l'examen",
    eus: 'Emaitza-egingoaren eguna',
    pt: 'Dia do exame'
  },
  LAST_UPDATE: {
    es: 'Última actualización',
    en: 'Last update',
    cat: 'Última actualització',
    eus: 'Azken eguneratzea',
    pt: 'Última atualização'
  },
  LAST_ACHIEVEMENT: {
    es: 'Última realización',
    en: 'Last achievement',
    cat: 'Última realització',
    eus: 'Azken egitea',
    pt: 'Última realização'
  },
  VIEW_TEST: {
    es: 'Ver test',
    en: 'View test',
    cat: 'Veure test',
    eus: 'Testa ikusi',
    pt: 'Ver teste'
  },
  VIEW_INFO: {
    es: 'Ver información',
    en: 'View information',
    cat: 'Veure informació',
    eus: 'Informazioa ikusi',
    pt: 'Ver informação'
  },
  NO_EXAMS_FOUND: {
    es: 'No hay exámenes',
    en: 'No exams found',
    cat: 'No hi ha exàmens',
    eus: 'Emaitza-egingoak ez',
    pt: 'Nenhum exame encontrado'
  },
  ONLINE_EXAM: {
    es: 'Examen online',
    en: 'Online exam',
    cat: 'Examen en línia',
    eus: 'Online emaitza-egingo',
    pt: 'Exame online'
  }
};
